import ReduxAlert from './redux-alert';

export default ReduxAlert;